import { Controller } from '@hotwired/stimulus'
import { AddressAPI } from "../utils/address_api"
import { OrderAPI } from "../utils/order_api"

export default class extends Controller {
    cancel() {
        $(this.element).modal('hide')
        Turbolinks.visit(location.toString())
    }

    accept(){
        $(this.element).modal('hide');
        let addressApi = AddressAPI()
        let address = $(this.element).data("address")
        let placeName = $(this.element).data("placeName")
        let orderNumber = $(this.element).data("orderNumber")
        let orderGuestToken = $(this.element).data("orderGuestToken")
        let coordinates = $(this.element).data("coordinates")

        addressApi.setCookies(placeName, address.zipcode, address.city, address.state, coordinates)

        if(orderGuestToken && orderGuestToken != "") {
            OrderAPI().emptyOrder(orderNumber, orderGuestToken)
            this.resetShoppingBagItemCount();
        }

        if(address.address && address.zipcode) {
            addressApi.saveAddress(address)
        } else {
            Turbolinks.visit(location.toString())
        }

        new clearGarlic().destroy()
    }

    resetShoppingBagItemCount(){
        document.getElementsByClassName('shopping-bag-item-count')[0].innerText = "0";
    }
}
